export default "__VITE_ASSET__058acac1__"